import React, { useState, useEffect } from "react";
import { Box, TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody} from "@mui/material";
import {useSelector} from "react-redux"
import KhmTransDetailDialog from "./KhmTransDetailDialog"
import CustomPagination from "../../component/common/CustomPagination";

export interface KmDataType {
  idx: number;
  site_name: string;
  title_km: string;
  url: string;
  text_km: string;
  issue_date: string;
  writer_km: string;
  copyrighter_km: string;
  orgext: string;
  data_type: string;
  topic_km: string;
  keyword_km: string;
  keyword2_km: string;
  worker: string;
  work_date: string;
  work_yn: string;
  prc_date: string;
  prc_yn: string;

  title_ko: string;
  text_ko: string;
  keyword_ko: string;

  title_en: string;
  text_en: string;
  keyword_en: string;
}

const initailData: KmDataType = {
  idx: -1,
  site_name: "",
  title_km: "",
  url: "",
  text_km: "",
  issue_date: "",
  writer_km: "",
  copyrighter_km: "",
  orgext: "",
  data_type: "",
  topic_km: "",
  keyword_km: "",
  keyword2_km: "",
  worker: "",
  work_date:"",
  work_yn:"",
  prc_date:"",
  prc_yn:"",

  title_ko: "",
  text_ko: "",
  keyword_ko: "",

  title_en: "",
  text_en: "",
  keyword_en: "",
};

interface pageInfoType {
  current_page: number;
  total_pages: number;
  total_count: number;
}

const KhmListPage = (props:any) => {

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;
  
  // const worker = useSelector((state:any)=> state.userInfo.data.user.user_id)

  const worker = auth.user.roles.filter((obj:any) => obj.role === 'KHM').map((info:any) => info.user_id)[0];   
  
  const [data, setData] = useState<KmDataType>(initailData);

  const [pagination, setPagination] = useState<pageInfoType | undefined>(
    undefined
  );
  
  const updateAfter = () => {
    setData(initailData);
    props.kmWorkList(props.work_yn);
  }

  useEffect(() => {
    if(props.workList.datas != undefined){
      setData(props.workList.datas[0])
    }
    if(props.workList.pagination != undefined){
      setPagination(props.workList.pagination)
    }
  },[props])

  return (
    <Box>
      {/* Task 단위 화면 */}
      <Box display="flex" justifyContent="center" >
        <Box sx={{padding:"20px 8px 8px 8px", width:"280px"}}>
          <Box display="flex">
            <Box><img style={{width:"34px", marginLeft:"8px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/km_flag.jpg'} /></Box>
            <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>Khmer Data</Box>
          </Box>
          <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
          <TableContainer sx={{maxHeight:"680px",fontSize:"12px"}}>
            <Table size="small" aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>IDX</Box></TableCell>
                  {/* <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>CONCEPT</Box></TableCell>
                  <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>USE_CHECK</Box></TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
              {(props.workList.datas != undefined && props.workList.datas.length > 0) ? props.workList.datas.map((row:any, index:number) => (
                <TableRow
                  key={index}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer', ':hover': { backgroundColor: '#e1e1ee' } , backgroundColor:(data != undefined && row.idx === data.idx ? "#dbdbef": "#fff")}}
                  onClick={()=> {setData(row);}}
                >
                  <TableCell component="th" scope="row" align="center">{row.idx}</TableCell>
                  {/* <TableCell align="left">{row.concept_en}</TableCell> */}
                  {/* <TableCell align="left">
                    <Box sx={{width:"58px",fontSize:"14px", marginLeft:"8px", padding: "2px 6px 2px 6px", borderRadius:"4px",
                        border: (row.use_check === "F" ? "2px solid red" : (row.use_check === "T" ? "2px solid #498ad5" : (row.use_check === "C" ? "2px solid #27cc2f" : "#bbb"))), color:"#000" }}>
                      {(row.use_check === "T" ? "사용가능" : (row.use_check === "F" ? "사용불가" : (row.use_check === "C" ? "내용수정":"미분류")))}
                    </Box>
                  </TableCell> */}
                </TableRow>
                )):<TableRow><TableCell colSpan={3} component="th" scope="row" align="center">데이터가 없습니다.</TableCell></TableRow>}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{marginTop:"12px"}}>
            {pagination !== undefined ? (
                <CustomPagination pagination={pagination} goPage={props.goPage} />
            ) : ""}
          </Box>
        </Box>
        <KhmTransDetailDialog rowDetail={data} updateAfter={updateAfter} worker={worker} work_yn={props.work_yn} />
      </Box>
    </Box>


  );
};

export default KhmListPage;
